import SEOHead from "@/components/SEOHead";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background py-16">
      <SEOHead
        title="Mentions légales | Immovox"
        description="Mentions légales du site Immovox.fr, édité par KALYVOX SASU. Informations juridiques et hébergeur."
        canonical="/mentions-legales"
      />
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-8">Mentions Légales</h1>
        
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Éditeur du site</h2>
            <p className="text-muted-foreground mb-4">
              Le site Immovox est édité par :<br />
              <strong>KALYVOX SASU</strong><br />
              Société par Actions Simplifiée Unipersonnelle au capital de 1 000 euros<br />
              Siège social : 6 place du Président Thomas Woodrow Wilson, 31000 Toulouse<br />
              RCS Toulouse : 999 458 409
            </p>
            <p className="text-muted-foreground mb-4">
              <strong>Immovox</strong> est une marque commerciale de KALYVOX SASU.
            </p>
            <p className="text-muted-foreground">
              Directeur de la publication : Alexandre Bougra<br />
              Contact : <a href="mailto:contact@immovox.fr" className="text-accent hover:underline">contact@immovox.fr</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Hébergement</h2>
            <p className="text-muted-foreground">
              Le site et l'application sont hébergés par :<br />
              <strong>Supabase Inc.</strong><br />
              970 Toa Payoh North #07-04, Singapore 318992<br />
              <br />
              Infrastructure cloud :<br />
              <strong>Amazon Web Services (AWS)</strong><br />
              Région : Europe (Paris) eu-west-3
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. Propriété intellectuelle</h2>
            <p className="text-muted-foreground mb-4">
              L'ensemble des éléments figurant sur le site Immovox (textes, graphismes, logos, icônes, images, 
              clips audio et vidéo, logiciels, base de données, etc.) sont protégés par les dispositions du 
              Code de la Propriété Intellectuelle.
            </p>
            <p className="text-muted-foreground">
              Toute reproduction, représentation, modification, publication, transmission, dénaturation, totale 
              ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support 
              que ce soit, est interdite sans l'autorisation écrite préalable de KALYVOX SASU.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Protection des données personnelles</h2>
            <p className="text-muted-foreground mb-4">
              Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement 
              Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, 
              de suppression et de portabilité de vos données personnelles.
            </p>
            <p className="text-muted-foreground">
              Pour exercer ces droits, vous pouvez nous contacter à : <a href="mailto:dpo@immovox.fr" className="text-accent hover:underline">dpo@immovox.fr</a><br />
              Pour plus d'informations, consultez notre <a href="/confidentialite" className="text-accent hover:underline">Politique de Confidentialité</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Cookies</h2>
            <p className="text-muted-foreground">
              Le site Immovox utilise des cookies strictement nécessaires au fonctionnement du service 
              (authentification, session utilisateur). Aucun cookie publicitaire ou de tracking tiers 
              n'est utilisé sans votre consentement explicite. Vous pouvez configurer votre navigateur 
              pour refuser les cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Limitation de responsabilité</h2>
            <p className="text-muted-foreground">
              KALYVOX SASU s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations 
              diffusées sur ce site. Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité 
              des informations mises à disposition sur ce site. Le service de qualification téléphonique 
              repose sur des technologies d'intelligence artificielle qui peuvent comporter des erreurs 
              d'interprétation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Droit applicable</h2>
            <p className="text-muted-foreground">
              Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux 
              de Toulouse seront seuls compétents.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <a href="/" className="text-accent hover:underline">← Retour à l'accueil</a>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;